<template>
  <f7-list-item class="superset-container"
                :checkbox="editable"
                :checked="checked"
                @change="onChange($event)"
  >
    <template v-slot:media>
      <div class="media" v-show="!editable">
        <transition name="fade">
          <f7-icon v-if="true" f7="link" style="font-size: 20px; z-index:2;"></f7-icon>
        </transition>
        <transition name="fade">
          <div v-if="true" class="link-icon-bg"></div>
        </transition>
      </div>
    </template>
    <li class="superset-activities">
      <activity-list-item v-for="(activity_id, index) in activity_ids"
                          :activity_id="activity_id"
                          :training_session="training_session"
                          :editable="false"
                          :sortable="false"
                          :active_navigation="!editable"
                          @swipeout:close="show_link_icon = true"
                          @swipeout="swipeout = $event"
                          :is_first="(is_first && index === 0)"
                          :is_last="(is_last && index === (activity_ids.length - 1))"
                          :f7router="f7router"
      ></activity-list-item>
    </li>
  </f7-list-item>
</template>

<script>

    import ActivityListItem from "./ActivityListItem.vue";

    export default {
        components: {
            ActivityListItem,
        },

        props: {
          'activity_ids': {},
          'training_session': {},
          'editable': {},
          'clear_checkbox': {},
          'is_last': {default: false},
          'is_first': {default: false},
          'f7router': {required: true},
        },

        mixins: [],

        data: function () {
            return {
                checked: false,
                show_link_icon: true,
                swipeout: 0,
            };
        },

        computed: {
            //
        },

        created() {
            //
        },

        mounted() {
            //
        },

        methods: {
            onChange(event) {
                this.checked = event.target.checked;
            }
        },

        watch: {
            clear_checkbox() {
                this.checked = false;
            },
            swipeout(value) {
                // console.log('swipeout value', value)
                this.show_link_icon = false;
            }
        }
    };
</script>
<style lang="scss">
  .superset-container {
    & > .item-content > .item-media {
      width: 0;
    }

    .muscle-image-container {
      padding-left: 1.5rem !important;
    }

    //.media.with-bg:before {
    //  background-color: white;
    //  width: 4px;
    //  height: 32px;
    //  content: '';
    //  left: 9px;
    //  top: -1px;
    //  position: absolute;
    //}

    .link-icon-bg {
      position:absolute;
      background:white;
      height: 32px;
      width:4px;
      top:-1px;
      left:9px;
      z-index:1;
    }

    .media {
      height: 100%;
      position: relative;
      right: 0;
      top: 3px;
      z-index: 3;
      padding-top: 5px;
      padding-bottom: 5px;

      & > .icon {
        font-size: 20px;
      }
    }
  }
</style>
